/* Section-local behavior; safe when Shopify inserts or reloads a section. */
(() => {
  function initialize(scope) {
    scope.querySelectorAll('.gallery-editions:not([data-bo-ready])').forEach(root => {
      root.dataset.boReady = 'true';
      const ox = root.querySelector('.bo-cmyk');
      if (!ox) return;
      const toggle = () => ox.setAttribute('aria-pressed', String(ox.getAttribute('aria-pressed') !== 'true'));
      ox.addEventListener('click', toggle);
      root.querySelectorAll('.bo-grid > article').forEach(card => {
        card.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch') toggle();
        });
        card.addEventListener('focusin', event => {
          if (!card.contains(event.relatedTarget) && !card.matches(':hover')) toggle();
        });
      });
      root.classList.add('bo-gallery-ready');
    });
    scope.querySelectorAll('.show-sell:not([data-bo-ready])').forEach(root => {
      root.dataset.boReady = 'true';
      const items = [...root.querySelectorAll('details[data-format]')];
      const select = item => {
        if (!item.open) return;
        items.forEach(other => { if (other !== item) other.open = false; });
        root.querySelectorAll('[data-image]').forEach(image => image.classList.toggle('is-active', image.dataset.image === item.dataset.format));
      };
      items.forEach(item => item.addEventListener('toggle', () => select(item)));
      const open = items.find(item => item.open);
      if (open) select(open);
      root.classList.add('bo-show-ready');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('.show-sell details[data-format]');
    if (item) item.open = true;
  });
})();
